export var ResponseType;
(function (ResponseType) {
    ResponseType["NOT_FOUND"] = "NOT_FOUND";
    ResponseType["NOT_VERIFIED"] = "NOT_VERIFIED";
})(ResponseType || (ResponseType = {}));
//# sourceMappingURL=types.js.map